import React from 'react';
import PropTypes from 'prop-types';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage } from 'react-intl';
import utils from '@/shared/utils/adminpulse';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import Checkbox from '@/shared/components/input/Checkbox';
import messages from '../jobMessages';

const JobDetailInitAbsenceCounter = ({ job, intl }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);
  if (!parameters) return null;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Year} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">{parameters.year}</div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Resource} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue list="resource" id={parameters.resourceId} fallback="" />
              </div>
            </div>
            {parameters.fromPreviousYear ? (
              <div className="row">
                <div className="col-md-5 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.CopyFromPreviousYear} />
                    </b>
                  </label>
                </div>
                <div className="col-md-7 col-sm-6">
                  <Checkbox value onClick={() => 0} />
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-5 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.AbsenceStartValue} />
                    </b>
                  </label>
                </div>
                <div className="col-md-7 col-sm-6">
                  {parameters.startValue}
                  &nbsp;
                  <FormattedMessage {...messages.Hours} />
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.OverrideIfCounterAlreadyExists} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <Checkbox value={parameters.overrideExisting} onClick={() => 0} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.RemoveExistingCorrections} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <Checkbox value={parameters.removeCorrections} onClick={() => 0} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailInitAbsenceCounter.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailInitAbsenceCounter);
